import {Player} from '@lottiefiles/react-lottie-player';

const FeaturesBox = () => {
  return (
    <div className="relative px-16 xs:px-6 flex flex-col gap-10 items-center justify-center" >
      <div className={`grid grid-cols-1 md:grid-cols-2 mb-20 w-full xs:border border-gray-600 rounded-lg xs:p-5`}>
        <div className="textSection items-center relative hidden xs:flex mb-10">
          <div className="pl-20 xs:pl-0">
            <Player
              autoplay
              loop
              src="https://cadence-fe-bucket.s3.us-east-2.amazonaws.com/lottieFilesJson/Estimate.json"
            >
            </Player>
          </div>
          <div className="w-96 h-64 right-24 xs:hidden z-1 top-0 absolute origin-top-left rotate-[-15deg] opacity-40 bg-gradient-to-tr from-blue-700 via-indigo-800 to-blue-700 rounded-2xl blur-3xl" />
        </div>

        <div className="imageSection flex flex-col px-20 xs:px-0 xs:mb-1 mb-10 ">
          <div className="text-white text-4xl xs:text-lg font-bold font-['Inter'] mb-2">AI-Driven Precision Estimates</div>
          <div className=" text-gray-400 text-lg xs:text-sm font-normal font-['Inter'] mb-3">Say goodbye to the resource-draining task of sizing estimates. Cadencepro.ai swiftly utilizes your organization’s domain knowledge and accurately calculates all project execution parameters in a safe simulation space, allowing your top talents to focus on strategic initiatives.</div>
          <div className="text-gray-400 text-sm font-medium font-['Work Sans'] uppercase mb-3">Empowers</div>
          <div className="flex gap-2">
            <div className="text-gray-400 px-2.5 py-2  rounded-lg border border-gray-400 text-xs font-medium font-['Work Sans'] uppercase ">SWIFT ACCURACY</div>
            <div className="text-gray-400 px-2.5 py-2  rounded-lg border border-gray-400 text-xs font-medium font-['Work Sans'] uppercase ">DOMAIN KNOWLEDGE</div>
          </div>
        </div>
        <div className="textSection flex items-center relative xs:hidden">
          <div className="pl-20 xs:pl-0">
            <Player
              autoplay
              loop
              src="https://cadence-fe-bucket.s3.us-east-2.amazonaws.com/lottieFilesJson/Estimate.json"
              className="rounded-lg"
            >
            </Player>
          </div>
          <div className="w-96 h-64 right-24 xs:hidden z-1 top-0 absolute origin-top-left rotate-[-15deg] opacity-40 bg-gradient-to-tr from-blue-700 via-indigo-800 to-blue-700 rounded-2xl blur-3xl" />
        </div>
      </div>

      <div className={`grid grid-cols-1 md:grid-cols-2 mb-20 w-full xs:border border-gray-600 rounded-lg xs:p-5`}>
        <div className="textSection flex items-center relative xs:mb-4">
          <div className="pl-20 xs:pl-0">
            <Player
              autoplay
              loop
              src="https://cadence-fe-bucket.s3.us-east-2.amazonaws.com/lottieFilesJson/Resource-Allocation.json"
              className="rounded-lg"
            >
            </Player>
          </div>
        </div>

        <div className="imageSection flex flex-col px-20 xs:px-0 xs:mt-1">
          <div className="text-white text-4xl xs:text-lg font-bold font-['Inter'] mb-2">Strategic Resource Allocation</div>
          <div className=" text-gray-400 text-lg xs:text-sm font-normal font-['Inter'] mb-3">No more hesitation in allocating resources. Cadencepro.ai optimizes resource management using AI, ensuring your key personnel can confidently handle crucial tasks without being overwhelmed.</div>
          <div className="text-gray-400 text-sm font-medium font-['Work Sans'] uppercase mb-3">Empowers</div>
          <div className="flex gap-2">
            <div className="text-gray-400 px-2.5 py-2  rounded-lg border border-gray-400 text-xs font-medium font-['Work Sans'] uppercase ">Decision-Making</div>
            <div className="text-gray-400 px-2.5 py-2  rounded-lg border border-gray-400 text-xs font-medium font-['Work Sans'] uppercase ">Balanced Workload</div>
          </div>
        </div>
      </div>


      <div className={`grid grid-cols-1 md:grid-cols-2 w-full xs:border border-gray-600 rounded-lg xs:p-5`}>
        <div className="textSection xs:flex items-center relative hidden mb-10">
          <div className=" max-h-96 pl-20 xs:pl-0">
            <Player
              autoplay
              loop
              src="https://cadence-fe-bucket.s3.us-east-2.amazonaws.com/lottieFilesJson/Dynamic-Project-Prioritization.json"
              className="rounded-lg"
            >
            </Player>
          </div>
        </div>

        <div className="imageSection flex flex-col px-20 xs:px-0 xs:mb-1 mb-10">
          <div className="text-white text-4xl xs:text-lg font-bold font-['Inter'] mb-2">Dynamic Project Prioritization</div>
          <div className=" text-gray-400 text-lg xs:text-sm font-normal font-['Inter'] mb-3">End the anxiety of continual reprioritization. Our AI seamlessly maps the impacts of decisions on both existing and new projects, offering instant clarity for informed decisions. Manage your projects in a safe "simulation" space.</div>
          <div className="text-gray-400 text-sm font-medium font-['Work Sans'] uppercase mb-3">Empowers</div>
          <div className="flex gap-2">
            <div className="text-gray-400 px-2.5 py-2  rounded-lg border border-gray-400 text-xs font-medium font-['Work Sans'] uppercase ">Simulative Foresight</div>
            <div className="text-gray-400 px-2.5 py-2  rounded-lg border border-gray-400 text-xs font-medium font-['Work Sans'] uppercase ">Impactful Prioritization</div>
          </div>
        </div>
        <div className="textSection flex items-center relative xs:hidden">
          <div className=" h-96 pl-20 xs:pl-0">
            <Player
              autoplay
              loop
              src="https://cadence-fe-bucket.s3.us-east-2.amazonaws.com/lottieFilesJson/Dynamic-Project-Prioritization.json"
              className="rounded-lg"
            >
            </Player>
          </div>
        </div>
      </div>



      <div className={`grid grid-cols-1 md:grid-cols-2 mb-20 w-full xs:border border-gray-600 rounded-lg xs:p-5`}>
        <div className="textSection flex items-center relative xs:mb-4">
          <div className="pl-20 xs:pl-0">
            <Player
              autoplay
              loop
              src="https://cadence-fe-bucket.s3.us-east-2.amazonaws.com/lottieFilesJson/Escalation-Handling.json"
              className="rounded-lg"
            >
            </Player>
          </div>
        </div>

        <div className="imageSection flex flex-col px-20 xs:px-0 xs:mt-1">
          <div className="text-white text-4xl xs:text-lg font-bold font-['Inter'] mb-2">Efficient Escalation Handling</div>
          <div className=" text-gray-400 text-lg xs:text-sm font-normal font-['Inter'] mb-3">Navigate escalations confidently with Cadencepro.ai AI-powered solution. Anticipate and manage customer and personnel escalations seamlessly, providing you with insights to handle tense moments with ease.</div>
          <div className="text-gray-400 text-sm font-medium font-['Work Sans'] uppercase mb-3">Empowers</div>
          <div className="flex gap-2">
            <div className="text-gray-400 px-2.5 py-2  rounded-lg border border-gray-400 text-xs font-medium font-['Work Sans'] uppercase ">Insightful</div>
            <div className="text-gray-400 px-2.5 py-2  rounded-lg border border-gray-400 text-xs font-medium font-['Work Sans'] uppercase ">Proactive Resolution</div>
          </div>
        </div>
      </div>

    </div>
  )
}

export default FeaturesBox;